module.exports = __webpack_public_path__ + "static/TownOfLight1-8b5b7bc9ac22a9fbcc7700f963442848.png";